import React from 'react';
export function Footer() {
  return <footer className="bg-wellness-dark text-white/70 py-12 px-4 text-center" data-id="element-39">
      <div className="max-w-4xl mx-auto" data-id="element-40">
        <p className="mb-4 font-heading text-xl text-white" data-id="element-41">
          Programa Antiinflamatorio Natural
        </p>
        <p className="text-sm mb-6" data-id="element-42">
          Descargo de responsabilidad: Este producto no sustituye el consejo
          médico profesional. Consulte a su médico antes de comenzar cualquier
          dieta o programa de salud, especialmente si tiene condiciones médicas
          preexistentes.
        </p>

        <p className="text-xs" data-id="element-43">
          &copy; {new Date().getFullYear()} Programa Antiinflamatorio Natural.
          Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}